// src/pages/Profile.jsx

export default function Profile() {
  return (
    <iframe
      src="https://www.canva.com/design/DAHFaO4nja0/HbEe2HIwaUDdCXqlomYLSA/view?embed"
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        border: 'none',
      }}
      allowFullScreen
      title="Galaxy Shipping Company Profile"
    />
  );
}